import { IComponentOptions } from "angular";
import { MachineChangeComponentController } from "./controller";

import {
  MultipleMachineChangeChildStateConfig,
  vsMultiServiceName,
} from "./multipleProvider";

export const vsMultiComponentName = "machineChangesMultiple";

class MachineChangeComponentControllerMultiple extends MachineChangeComponentController<MultipleMachineChangeChildStateConfig> {
  static $inject = [vsMultiServiceName];
}

export const MachineChangeMultipleComponentOptions: IComponentOptions = {
  controller: MachineChangeComponentControllerMultiple,
  controllerAs: "machineChangeController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    disabled: "<",
    childClicked: "&",
    childDisabled: "&?",
  },
};
